import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './redux/store'
import { StyledEngineProvider, Theme } from '@mui/material/styles'
import { ThemeModeProvider } from './contexts/ThemeModeContext'
import { eventLogger, keycloak } from './services/keycloak.service'
import { loadStoredTokens, persistTokens } from './services/auth.service'
import { BrowserRouter } from 'react-router-dom'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import './i18next'

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const next = store.dispatch
store.dispatch = function dispatchAndLog(action) {
  console.log('dispatching', action)
  let result = next(action)
  console.log('next state', store.getState())
  return result
}

// Login řeší naše obrazovka (ROPC) — žádný redirect na Keycloak.
// Init dostane tokeny z localStorage; bez nich zůstane nepřihlášeno
// a router zobrazí LoginPage.
export const keycloakInitConfig = {
  checkLoginIframe: false,
  ...(loadStoredTokens() || {}),
}

ReactDOM.render(
  <React.StrictMode>
    <ReactKeycloakProvider
      authClient={keycloak}
      onEvent={eventLogger(store)}
      onTokens={persistTokens}
      initOptions={keycloakInitConfig}
    >
      <Provider store={store}>
        <BrowserRouter basename={'/itrader'}>
          <StyledEngineProvider injectFirst>
            <ThemeModeProvider>
              <App />
            </ThemeModeProvider>
          </StyledEngineProvider>
        </BrowserRouter>
      </Provider>
    </ReactKeycloakProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
